/**
 * @fileOverview This file manages the locale state for data grid tables using Jotai atoms
 * @module tableLocaleAtom
 */

import { atom } from 'jotai';
import { enUS, esES } from '@mui/x-data-grid-pro';

/**
 * Gets the appropriate locale configuration based on language code
 * @param {string} language - The language code ('es' for Spanish, defaults to English)
 * @returns {Object} The locale configuration object for the data grid
 */
export const getLocaleFromLanguage = (language) => {
  const locale = language === 'es' ? esES : enUS;
  return locale;
};

/**
 * Jotai atom that stores the current table locale configuration
 * Initialized with Spanish (esES) locale by default
 * @type {import('jotai').Atom<Object>}
 */
export const tableLocaleAtom = atom(esES);
